import { useAction } from '@reatom/npm-react'
import { useEffect } from 'react'
import styled, { css } from 'styled-components'

import { PairLink } from '@root/entities/pair/ui/common'
import { AppDataTable } from '@root/features/app-data-table/app-data-table'
import { reatomFavoritePairsTable } from '@root/features/favorite-pairs/atoms/reatom-favorite-pairs-table'
import { FavoriteUnavailable } from '@root/features/favorite-pairs/model/favorite-unavailable'
import { useAppRoutes } from '@root/features/routing'

import { FavoritesTableEmpty } from './favorites-table-empty'

import type { PairModel } from '@root/entities/pair'

type Props = {
  onClose: () => void
}

// eslint-disable-next-line @reatom/unit-naming-rule
const model = reatomFavoritePairsTable()

export const FavoritesTable: React.FC<Props> = ({ onClose }) => {
  const { navigateToRoot } = useAppRoutes()
  const refresh = useAction(model.refresh)

  useEffect(() => {
    refresh()
  }, [refresh])

  const handleExploreTokens = () => {
    navigateToRoot()
    onClose()
  }

  return (
    <AppDataTable
      css={css`
        height: 100%;
      `}
      model={model}
      renderBackgroundLink={(args) => {
        if (args.data instanceof FavoriteUnavailable) {
          return undefined
        }
        return (
          <PairLinkWrapper
            pair={args.data}
            onClick={(event) => {
              const openInNewTab =
                event.ctrlKey || event.metaKey || event.button === 1

              if (openInNewTab) {
                return
              }

              onClose()
            }}
          />
        )
      }}
      rowHeight={50}
      renderEmptyMessage={() => (
        <FavoritesTableEmpty onRetry={handleExploreTokens} intent="empty" />
      )}
      renderError={() => (
        <FavoritesTableEmpty onRetry={refresh} intent="error" />
      )}
    />
  )
}

const PairLinkWrapper = styled(PairLink<PairModel>)`
  position: absolute;
  inset: 0;
  z-index: 0;
`
